export const toPage = (type: string) => {
  const env = process.env.REACT_APP_ENV;
  console.log(env);
  let href = `https://srm-supplier.ywwl.com/${type}`;
  switch (env) {
    case 'dev':
      href = `https://srm-supplier-dev.ywwl.com/${type}`;
      break;
    case 'test':
      href = `https://srm-supplier-test.ywwl.com/${type}`;
      break;
    default:
      href = `https://srm-supplier.ywwl.com/${type}`;
  }
  if (type === 'login') {
    window.open(href + '?loginType=settled');
  } else {
    window.open(href);
  }
};
